import React, { useState } from 'react'
import { PrivacyShieldProps } from '../types'
import { Stack, Typography } from '@mui/material'
import { ReactComponent as LockIcon } from '../../../assets/images/Lock.svg'
import SvgIcon from '@mui/material/SvgIcon'
import Checkbox from '@mui/material/Checkbox'
import Button from '@mui/material/Button'
import { FormControlLabel } from '@mui/material/'

export const PrivacyShield: React.FC<PrivacyShieldProps> = ({ onClick }) => {
    let [isChecked, setIsChecked] = useState(false)
    const setCheckBox = () => {
        setIsChecked((prev) => {
            return !prev
        })
    }

    return (
        <Stack className="privacy-shield">
            <Stack className="privacy-shield-content">
                <Typography className="privacy-schield-subtext">
                    This mode protects the workspaces you’re logged into. Your organizations will appear once privacy is
                    confirmed.
                </Typography>
                <Typography className="privacy-shield-icon">
                    <SvgIcon
                        component={LockIcon}
                        inheritViewBox
                        fontSize="small"
                        color="inherit"
                        sx={{ fontSize: '90px' }}
                    />
                </Typography>
            </Stack>
            <Stack
                direction="row"
                justifyContent="space-between"
                gap={5}
                mb={1}
                className="privacy-shield-text"
                color="figma.grayscale.textHier1"
            >
                <Stack direction="row" justifyContent="space-between" gap={1}>
                    <FormControlLabel
                        control={<Checkbox checked={isChecked} onChange={setCheckBox} name="antoine" />}
                        label="I'm Ready!"
                    />
                </Stack>
                <Button disabled={!isChecked} onClick={onClick} variant="text">
                    SHOW ORGANIZATION
                </Button>
            </Stack>
        </Stack>
    )
}
